import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-declaracao-financiamento',
  templateUrl: './declaracao-financiamento.component.html'
})
export class DeclaracaoFinanciamentoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
